import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Router, Switch, Route } from 'react-router-dom';
import ProviderWithRouter from './ProviderWithRouter';
import AddSearchClient from 'addsearch-js-client';

import EnterCarDetailsPage from 'pages/EnterCarDetailsPage';
import EnterUserDetailsPage from 'pages/EnterUserDetailsPage';
import NotFound from './pages/NotFound';
import ValuationPage from 'pages/ValuationPage';

import { Header, Footer, WithViewport } from 'Olympus';
import { viewportMediaQueries } from './variables/viewports';

import LoadingSpinner from './components/LoadingSpinner';
import { Grid, Row, Col } from 'components/Grid';
import ScrollToTop from 'components/ScrollToTop';

import style from './App.scss';
import 'tooltip.css';

export default class App extends Component {
  static propTypes = {
    theme: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({}).isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      addSearchUI: {},
      ready: false
    };

    this.addSearchClient = new AddSearchClient(process.env.ADD_SEARCH_KEY);
  }

  componentDidMount() {
    if (typeof this.addSearchUI === 'undefined') {
      const AddSearchUI = require('addsearch-search-ui');
      this.addSearchUI = new AddSearchUI(this.addSearchClient);
    }

    this.setState({ ready: true });
  }

  render() {
    const { history } = this.props;
    const { ready } = this.state;
    return (
      ready && (
        <Router history={history}>
          <ProviderWithRouter>
            <div className={style.app}>
              <div className={style.content}>
                <ScrollToTop>
                  <WithViewport viewportMediaQueries={viewportMediaQueries}>
                    {viewport => {
                      return (
                        <Header
                          viewport={viewport}
                          whatCarUrl={`${WHATCAR_URL}`}
                          addSearchClient={this.addSearchClient}
                          addSearchUI={this.addSearchUI}
                          newCbeUrl={'https://newcarbuying.whatcar.com'}
                        />
                      );
                    }}
                  </WithViewport>
                  <Switch>
                    <Route
                      path="/car-valuation/enter-user-details"
                      component={EnterUserDetailsPage}
                    />
                    <Route
                      path="/car-valuation/valuation"
                      component={ValuationPage}
                    />
                    <Route
                      exact
                      path="/car-valuation"
                      component={EnterCarDetailsPage}
                    />
                    <Route component={NotFound} />
                  </Switch>
                </ScrollToTop>
              </div>
              <div className={style.footer}>
                <WithViewport viewportMediaQueries={viewportMediaQueries}>
                  {viewport => (
                    <Grid>
                      <Row>
                        <Col colXs={12}>
                          <Footer
                            viewport={viewport}
                            whatCarUrl={`${WHATCAR_URL}`}
                          />
                        </Col>
                      </Row>
                    </Grid>
                  )}
                </WithViewport>
              </div>
              <LoadingSpinner />
            </div>
          </ProviderWithRouter>
        </Router>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js